import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RestartComponent } from './components/restart/restart.component';
import { titleResolver } from './core/utils/utils.service';
import { canActivateLogin, canActivateMain } from './core/guards/auth.guard';


export const routes: Routes = [
  {
    path: 'main',
    redirectTo: '',
    // redirectTo: 'nurse',
    pathMatch: 'full'
  },
  {
    path: 'restart',
    canActivate: [],
    component: RestartComponent
  },
  {
    path: 'login',
    canMatch: [canActivateLogin],
    // title: titleResolver({
    //   baseTitle: $localize`:Browser Tab Name|Login@@appRoutingLogin:`,
    //   param: '',
    //   suffix: ''
    // }),
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
    data: { reuse: false },
  },
  {
    path: '',
    canActivate: [],
    canMatch: [canActivateMain],
    title: titleResolver({
      baseTitle: $localize`:Browser Tab Name|Page with a list of selectable projects@appRoutingMain:Web Display Selector`,
      param: '',
      suffix: ''
    }),
    loadChildren: () => import('./modules/main/dynamic-main.module').then(m => m.DynamicMainModule),
  },
  {
    path: '**', redirectTo: 'login',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
